import React, { Component } from 'react'
import { /*Paragraph,*/ Box, Button } from 'grommet';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Header from './Header';
/*import Footer from './Footer';*/


class ErrorPage extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {

        }
        this.redirectLogin = this.redirectLogin.bind(this);
        //this.redirectSettingFistStep = this.redirectSettingFistStep.bind(this);
        this.redirectHome= this.redirectHome.bind(this);
        this.redirectDispute = this.redirectDispute.bind(this);
    }


    /*redirectSettingFistStep() {
        this.props.firstStep();
    }*/

    redirectLogin(){        
        this.props.history.push('/login');
    }

    redirectHome() {
        this.props.history.push('/Home');
    }

    redirectDispute() {
        this.props.history.push('/DisputeOnlineRegistered');
    }

    render() {
        const outcome = 
       
                <Box>
                    <Header />
                    <Box style={{ height: '81px' }}/>
                    <Box align='center' className='content' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }}>
                        <Box className='contentbox' style={{ height: '300px' }}>
                            <Box direction="column" align='center'>
                                <h1 className='fixFont' level='1' style={{ marginBottom: '50px', color:'#E1242B' }}>Ops! Qualcosa non va...</h1>
                                {/*<Paragraph className='textParagraph' style={{ textAlign: 'center' }}>{this.props.values.dataOTP ? "La modifica è stata effettuata correttamente." : "Spiacenti, la modifica richiesta non è andata a buon fine."}</Paragraph>*/}
                            </Box>
                        <Box align='center'>
                            {window.location.pathname === '/ErrorPageReg' ?
                                <Button color='transparent' className='btnform' label='Login' onClick={this.redirectLogin} />
                            : this.props.location.path === "dispute" ?
                                <Button color='transparent' className='btnform' label='TORNA A GESTIONE DISPUTE' onClick={this.redirectDispute} />
                            :    
                                <Button color='transparent' className='btnform' label='Home' onClick={this.redirectHome} />
                            }
                        </Box>
                    </Box>
                        
                    </Box>
                </Box>



        return (
            <Box style={{ margin: window.location.pathname !== '/InsertTelephone' ? '0 auto' : '' }}>
                {outcome}
            </Box>
        )
    }
}

export default withRouter(ErrorPage)